import { data } from "react-router-dom";
import { apiHandler, getEventRowId } from "./apiHandler";

// Fetch Groups
export const fetchGroups = async () => {
  const data = {
    fn: "common_fn",
    se: "fe_gr",
    data: { "event_row_id": "1734588502872_rNpA" },
  };
  return await apiHandler(data);
};

// Fetch Teams
export const fetchTeams = async () => {
  const data = {
    fn: "common_fn",
    se: "fe_te",
    data: { "event_row_id":"1734588502872_rNpA"  },
  };
  return await apiHandler(data);
};

// Fetch Players of Team
export const fetchPlayersOfTeam = async (teamRowId) => {
  const data = {
    fn: "common_fn",
    se: "fe_pl_te",
    data: { team_row_id: teamRowId, "event_row_id": "1734588502872_rNpA" },
  };
  return await apiHandler(data);
};
// Fetch Sports
export const fetchSports = async () => {
  const data = {
    fn: "common_fn",
    se: "fe_sp",
    data: {

    },
  };
  return await apiHandler(data);
};


// Fetch Games
export const fetchGames = async (sport_row_id) => {
  const data = {
    fn: "common_fn",
    se: "fe_ga",
    data: { event_row_id: "1734588502872_rNpA",
      sport_row_id
     },
     
  };
  
  return await apiHandler(data);
};



// Fetch fetch Top 5 Teams 

export const fetchTopTeams = async () => {
  const data = {
    fn:"common_fn",
    se:"fe_tp5_te",
    data: { event_row_id: "1734588502872_rNpA" },

  }
  return await apiHandler(data)
}



// Fetch All Teams Points

export const fetchAllTeamsPoints = async() => {
  const data = {
    fn:"common_fn",
    se:"fe_al_te_pts",
    data: { event_row_id: "1734588502872_rNpA" },
  }
  return await apiHandler(data)

}

// Fetch Teams Points By Group

export const fetchTeamsPointsByGroup = async() => {
  const data = {
    fn:"common_fn",
    se:"fe_te_gr",
    data: { event_row_id: "1734588502872_rNpA" },
  }
  return await apiHandler(data)

}


// Fetch total Games By Sports

export const totalGamesBySports= async() => {
  const data = {
    fn:"common_fn",
    se:"tot_ga_sp",
    data: { },
  }
  return await apiHandler(data)
}




// Fetch Teams Performance Game Wise



export const teamsPerformanceGroup = async(team_row_id) => {
  const data = {
    fn:"common_fn",
    se:"fe_te_pe_ga",
    data: { team_row_id,event_row_id: "1734588502872_rNpA" },
  }
  return await apiHandler(data)

}


// Fetch No of Matches By Sport

export const noMatchesBySport = async() => {
  const data = {
    fn:"common_fn",
    se:"fe_no_ma_sp",
    data: { event_row_id: "1734588502872_rNpA" },
  }
  return await apiHandler(data)
}
























